import { render } from "./Receipt.vue?vue&type=template&id=14181cce"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"
script.render = render

export default script